import React, { createContext, useContext, useState, useEffect } from "react";

const ACCENT_COLORS = {
  green: { accent: "30 215 96", link: "21 184 79", linkDark: "30 215 96" },
  blue: { accent: "96 165 250", link: "37 99 235", linkDark: "96 165 250" },
  pink: { accent: "244 114 182", link: "219 39 119", linkDark: "244 114 182" },
  purple: { accent: "167 139 250", link: "124 58 237", linkDark: "167 139 250" },
  orange: { accent: "251 146 60", link: "234 88 12", linkDark: "251 146 60" },
  red: { accent: "248 113 113", link: "220 38 38", linkDark: "248 113 113" },
};

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [mode, setMode] = useState("dark");
  const [accentName, setAccentName] = useState("purple");

  useEffect(() => {
    if (typeof document === "undefined") return;
    const html = document.documentElement;
    if (mode === "light") {
      html.classList.add("light");
    } else {
      html.classList.remove("light");
    }
  }, [mode]);

  useEffect(() => {
    if (typeof document === "undefined") return;
    const root = document.documentElement;
    const palette = ACCENT_COLORS[accentName] || ACCENT_COLORS.green;
    root.style.setProperty("--color-accent", palette.accent);
    root.style.setProperty("--color-link", mode === "dark" ? palette.linkDark : palette.link);
  }, [accentName, mode]);

  const toggleMode = (newMode) => {
    if (newMode === "dark" || newMode === "light") {
      setMode(newMode);
    }
  };

  const setAccent = (name) => {
    if (ACCENT_COLORS[name]) {
      setAccentName(name);
      return true;
    }
    return false;
  };

  return (
    <ThemeContext.Provider value={{ mode, accentName, toggleMode, setAccent, accentColors: Object.keys(ACCENT_COLORS) }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};
